<template>
  <div class="row">
    <div class="col">
      <div class="card">
        <!-- Card header -->
        <card-header :title="$router.currentRoute.meta.title" >
          <router-link v-if="!serverError" :to="{ name: `${routePrefix}.edit`,params:{id} }"  class="btn btn-primary btn-sm" v-can:edit="permissionPrefix">

            <i class="fa fa-edit"></i>
          </router-link>
        </card-header>
        <!-- Card body -->
          <div class="card-body">
            <div class="row">
              <div class="col-6">
                <div v-if="serverError" class="alert alert-danger">
                  <strong>{{ $t('labels.error') }} : </strong> {{ serverError }}
                </div>
              </div>
            </div>
            <div class="row" v-if="!serverError">
              <select-captain-bonus-types v-model="type" :options="{ id: 'captain_bonus_type', label: 'type', disabled: true }"/>
              <select-captain-bonus-owner-types v-model="owner_type" :options="{ id: 'captain_bonus_owner_type', label: 'owner_type', disabled: true }"/>
              <input-number v-model="owner_id" :options="{ id: 'owner_id', step: 1, label: 'owner_id', disabled: true }"/>
              <input-text v-model="name" :options="{ id: 'name', label: 'name', disabled: true }"/>
              <input-textarea v-model="description" :options="{ id: 'description', label: 'description', disabled: true }"/>
              <input-number v-model="revenue" :options="{ id: 'revenue', label: 'revenue', disabled:true }"/>
              <input-datetime v-model="from_date" :options="{ id: 'from_date', label: 'from_date', disabled: true }"/>
              <input-datetime v-model="to_date" :options="{ id: 'to_date', label: 'to_date', disabled: true }"/>
              <input-number v-model="whenDeliveredOrdersReaches" :options="{ id: 'whenDeliveredOrdersReaches', step: 1, transPrefix: `${transPrefix}.fields`, label: 'when_delivered_orders_reaches', disabled: true }"/>
            </div>
            <div class="row" v-if="!serverError">
              <input-checkbox v-model="enabled" :options="{ id: 'enabled', label: 'enabled', disabled: true }"/>
              <input-checkbox v-model="expired" :options="{ id: 'expired', label: 'expired', disabled: true }"/>
            </div>
          </div>
          <!-- Card footer -->
          <div class="card-footer">
            <div class="row">
              <div class="col text-right">
                <router-link :to="{ name: `${routePrefix}.index`}"  class="btn btn-neutral btn-sm">
                  <i class="fa fa-arrow-left"></i>
                </router-link>
              </div>
            </div>
          </div>
      </div>
    </div>
  </div>
</template>
<script>
  import { CAPTAIN_BONUSES_SHOW as CRUD_ACTION_SHOW } from 'actions/captain_bonuses';
  const CRUD_CODE="captain_bonuses";
  export default {
    name: "CaptainBonusShow",
    data(){
      return {
        routePrefix: CRUD_CODE,
        transPrefix: CRUD_CODE,
        permissionPrefix: `${CRUD_CODE}`,
        id:this.$router.currentRoute.params.id,
        type: '',
        owner_type: '',
        owner_id: '',
        name: '',
        description: '',
        revenue: '',
        whenDeliveredOrdersReaches:"",
        from_date: '',
        to_date: '',
        enabled: false,
        expired: false,
        serverError: '',
        image:{
          file:'',
          thumbnail:'',
        },
      }
    },
    mounted() {
      this.getItem();
    },
    methods: {
      getItem(){
        this.$store.dispatch(CRUD_ACTION_SHOW,{
          id: this.id,
        }).then(response=>{
          this.type=response.data.type;
          this.owner_type=response.data.ownerType;
          this.owner_id=response.data.ownerId;
          this.name=response.data.name;
          this.description=response.data.description;
          this.revenue=response.data.revenue;
          this.enabled=response.data.enabled;
          this.expired=response.data.expired;
          this.whenDeliveredOrdersReaches=response.data.data?response.data.data.whenDeliveredOrdersReaches:null;
          this.from_date=response.data.fromDate?this.$moment(response.data.fromDate).format("Y-MM-DDTHH:mm"):"";
          this.to_date=response.data.toDate?this.$moment(response.data.toDate).format("Y-MM-DDTHH:mm"):"";
        }).catch(error => {
          this.loading = false;
          this.serverError='';

          if(error.response){
            let responseData=error.response.data;

            if(responseData.errors){
              this.fieldErrors=responseData.errors;
            }else{
              this.serverError = 'Invalid Request.'
            }
          }else{
            this.serverError = this.$i18n.t("messages.no_internet_connection");
          }

          if(this.fieldErrors.error){
            this.serverError = this.fieldErrors.error;
          }
        });
      },
    }
  };
</script>
